import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: 'website' | 'article' | 'tool';
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title = 'Financial Math Retirement Planner',
  description = 'Advanced retirement planning tool with Monte Carlo simulations and historical backtesting. Calculate safe withdrawal rates and plan your retirement with confidence.',
  keywords = 'retirement planning, Monte Carlo simulation, safe withdrawal rate, portfolio analysis, financial planning, retirement calculator',
  image = 'https://portfolioplanner-1b415a288bfa.herokuapp.com/og-image.png',
  url = 'https://portfolioplanner-1b415a288bfa.herokuapp.com/',
  type = 'website'
}) => {
  const fullTitle = title === 'Financial Math Retirement Planner' 
    ? title 
    : `${title} | Financial Math Retirement Planner`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={image} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={url} />
    </Helmet>
  );
};

export default SEOHead;
